import { useContext } from 'react';
import { IaServicesApi } from '@europrocurement/l2d-domain/openApi/ApiIaService';
import L2DApiContext from '../L2DApiContext';

export const useIaServicesService = () => {
    const context = useContext(L2DApiContext);
    if (!context) {
        throw new Error('useL2DApi must be used within a L2DApiProvider');
    }
    if (!context.iaServices) {
        throw new Error('IaService service is not registred in L2DApiProvider');
    }
    const { apis } = context.iaServices;

    return {
        iaServicesApi: apis.iaServicesApi as IaServicesApi,
    };
};
